import React from 'react';

const Error = () => {
  return <div>Error page</div>;
};

export default Error;
